import { styled } from "@mui/material/styles";

export const Spacer = styled("div")`
  flex-grow: 1;
`;
